export default {"src":"/_next/static/media/patients.3fcb262e.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};